import AuthLayoutComponent from '../../features/ui/auth-layout/auth-layout';
import { RegisterForm } from '@old/features/public/register/register-form';

export function AgrologyRegisterPage() {
  return (
    <AuthLayoutComponent variant="agrology">
      <RegisterForm referralSource="agrology" />
    </AuthLayoutComponent>
  );
}
